import { Button } from '@library/components/buttons';
import rightArrowUrl from '@library/assets/images/icons/calendar-caret.svg';

export interface NextButtonProps {
  className?: string;
  disabled?: boolean;
  handleOnClick: () => void;
  label: string;
  testId?: string;
}

export const NextButton = ({
  className = '',
  disabled = false,
  handleOnClick,
  label,
  testId = 'next-button'
}: NextButtonProps) => {
  return (
    <Button
      aria-label={label}
      className={className}
      data-testid={testId}
      disabled={disabled}
      title="NextButton"
      onClick={handleOnClick}
      type="button"
    >
      <img
        alt="right arrow"
        className="relative -top-px rotate-180"
        src={rightArrowUrl}
      />
    </Button>
  );
};
